import cn from "../../utils/cn"
import { parseCsvList, parsePhysicians } from "./videoMetrics"

const physicianLabel = ({ name, npi }) => (name ? `${name} — ${npi}` : npi)

/*
  The referring physicians this report matched, with the one actually chosen
  raised onto a green band carrying its specialties.

  A single match is the selected one by definition — there was nothing to choose
  between. With several, only an exact NPI-and-name match counts, since the same
  name can appear under more than one NPI.
*/
const MatchedPhysicians = ({ detail }) => {
  const physicians = parsePhysicians(detail?.MatchingPhysicians)
  const specialties = parseCsvList(detail?.SelectedPhysicianSpecialties)
  const hasMultiple = physicians.length > 1

  return (
    <div className="bg-gray-50 rounded-xl p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
        Referring physicians
        {physicians.length > 0 && ` · ${physicians.length} matched`}
      </p>

      {physicians.length > 0 ? (
        <div className="rounded-lg overflow-hidden bg-white">
          {physicians.map((physician, index) => {
            const isSelected = hasMultiple
              ? physician.npi === detail.SelectedPhysicianNpi &&
                physician.name === detail.SelectedPhysicianName
              : true

            return (
              <div
                key={`${physician.npi}-${index}`}
                className={cn(
                  "flex flex-wrap items-center justify-between gap-2 px-3 py-2",
                  index > 0 && "border-t border-gray-100",
                  isSelected && "bg-green-50"
                )}
              >
                <span
                  className={cn(
                    "text-xs",
                    isSelected ? "font-medium text-green-700" : "text-gray-700"
                  )}
                >
                  {physicianLabel(physician)}
                </span>

                {isSelected && specialties.length > 0 && (
                  <div className="flex flex-wrap gap-1">
                    {specialties.map((specialty, specialtyIndex) => (
                      <span
                        key={`${specialty}-${specialtyIndex}`}
                        className="px-2 py-0.5 text-[10px] rounded-full bg-white border border-green-200 text-green-700"
                      >
                        {specialty}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      ) : (
        <span className="text-xs text-gray-400 italic">N/A</span>
      )}
    </div>
  )
}

export default MatchedPhysicians
